module.exports = __webpack_public_path__ + "img/pusher_item_3.e44d0b7d.png";